import React from "react";
import { CSVLink } from "react-csv";
import DateRange from "./DateRange";
import "../../static/css/FilterContainer.css";

const FilterContainer = React.memo(props => {
  let button = null;
  if (props["data"]) {
    const { Parser } = require("json2csv");
    const fields = props.csv_columns;
    const json2csvParser = new Parser({ fields });
    const csvData = json2csvParser.parse(props.csv_data);
    button = (
      <CSVLink
        data={csvData}
        filename={props.name + ".csv"}
        className="btn export-btn vertical-middle semi-bold"
        target="_blank"
      >
        <i className="icon icon-ic-excel vertical-middle" />
        <span className="vertical-middle">Export CSV</span>
      </CSVLink>
    );
  }
  return (
    <div className="meta-wrpr">
      <div className="desc-wrpr">
        <div className="container">
          <div className="pull-left">
            <h2 className="title light">Reporting</h2>
          </div>
          <div className="pull-right">
            <div className="date-wrpr">
              <DateRange
                {...props["Time Period"]}
                updateState={component =>
                  props.updateState("Time Period", component)
                }
                ChangeDashboardData={props.ChangeDashboardData}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="filter-wrpr width-change">
        <div className="container">
          <div className="pull-right">{button}</div>
        </div>
      </div>
    </div>
  );
});

export default FilterContainer;
